import React from 'react';
import { useMenuIconAnimation } from './useMenuIconAnimation';
import './HomeAnimatedIcon.css';

const ACTIVE_COLOR = '#3262FF';
const INACTIVE_COLOR = '#282932';

function HomeAnimatedIcon({ color, isActive = false, size = 22 }) {
  const strokeColor = color || (isActive ? ACTIVE_COLOR : INACTIVE_COLOR);
  const { playing, handleClick } = useMenuIconAnimation(isActive, 2200);

  return (
    <span
      className={[
        'home-animated-icon',
        playing ? 'home-animated-icon--playing' : '',
        isActive && !playing ? 'home-animated-icon--active' : '',
      ].filter(Boolean).join(' ')}
      style={{ '--home-icon-stroke': strokeColor, width: size, height: size }}
      onClick={handleClick}
      role="presentation"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <g className="home-icon-house-group">
          <path
            className="home-icon-house-fill"
            d="M4 10 L12 4 L20 10 V20 H4 V10 Z"
          />
          <path
            className="home-icon-stroke home-icon-house-body"
            d="M4 10 L12 4 L20 10 V20 H4 V10 Z"
          />
        </g>
        <path
          className="home-icon-stroke home-icon-top-angle"
          d="M2 6 L12 -2 L22 6"
        />
      </svg>
    </span>
  );
}

export default HomeAnimatedIcon;
